module.exports = __webpack_public_path__ + "media/images/pic/compare/old/before-929db69455f7bceadd829faa1691b3bf.jpg";